import './NowPlaying.css';
import { formatPercent } from '../utils/formatters';

const NowPlaying = ({ data }) => {
  if (!data) return null;

  const { movie, movieIndex, progress, users } = data;

  return (
    <div className="now-playing">
      <span className="now-playing__label">Now Playing</span>
      <h2 className="now-playing__title">{movie}</h2>
      <span className="now-playing__subtitle">Film {movieIndex} of 8</span>

      <div className="now-playing__progress">
        <div className="now-playing__progress-track">
          <div
            className="now-playing__progress-fill"
            style={{ width: formatPercent(progress) }}
          />
        </div>
        <span className="now-playing__progress-text">{formatPercent(progress)}</span>
      </div>

      <div className="now-playing__users">
        <span className="now-playing__users-label">Watching:</span>
        <span className="now-playing__users-list">{users.join(' & ')}</span>
      </div>
    </div>
  );
};

export default NowPlaying;
